import { useEffect } from "react";

// Homepage defaults (mirror public/index.html) restored when leaving a SEO page.
const BASE = {
  title: "B.health® — Restart Your Body | Centre santé & sport à Bruxelles (Berchem-Sainte-Agathe)",
  description:
    "Test Restart gratuit (3 min) et profil santé personnalisé : kiné, ostéo, nutrition et coaching à Bruxelles (Berchem-Sainte-Agathe). Réservez votre bilan.",
  url: "https://www.bhealth.be/",
};

function setAttr(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

/**
 * Dependency-free SEO head manager: sets <title>, meta description, canonical,
 * Open Graph / Twitter tags and injects a JSON-LD block. Restores homepage
 * defaults on unmount so client-side navigation keeps tags correct.
 */
export default function Seo({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('link[rel="canonical"]', "href", canonical);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", canonical);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="twitter:description"]', "content", description);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = BASE.title;
      setAttr('meta[name="description"]', "content", BASE.description);
      setAttr('link[rel="canonical"]', "href", BASE.url);
      setAttr('meta[property="og:title"]', "content", BASE.title);
      setAttr('meta[property="og:description"]', "content", BASE.description);
      setAttr('meta[property="og:url"]', "content", BASE.url);
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, canonical, jsonLd]);

  return null;
}
